'use client'

import type { ChainId, Fetchable, MarketId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import { isDefined } from '@morpho-org/morpho-ts'
import { useMemo } from 'react'

import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider'

import { getMarketWithPoints } from '../helpers/getPoints'

export interface UseMarketPointsProps {
  chainId?: Fetchable<ChainId>
  marketId?: Fetchable<MarketId>
  collateralAddress?: Fetchable<Address>
}

export function useMarketPoints({ chainId, marketId, collateralAddress }: UseMarketPointsProps) {
  const { showPoints } = useFeatureFlags()

  return useMemo(() => {
    if (!showPoints) {
      return []
    }

    if (!isDefined(chainId) || !isDefined(marketId)) {
      return []
    }

    return getMarketWithPoints(chainId, marketId, collateralAddress).filter(isDefined)
  }, [showPoints, chainId, collateralAddress, marketId])
}
